import { useQuery } from '@tanstack/react-query';
import { admin } from '@repletoryreach/sdk-api';

export function useBillingStats() {
  return useQuery({
    queryKey: ['admin', 'stats', 'billing'],
    queryFn: () => admin.billingStats()
  });
}

export function useInboxStats() {
  return useQuery({
    queryKey: ['admin', 'stats', 'inbox'],
    queryFn: () => admin.inboxStats()
  });
}
